import React from 'react';

const Image = ({ source, style, alt, resizeMode, ...props }) => {
  const convertStyle = (rnStyle) => {
    if (!rnStyle) return {};
    
    const cssStyle = { ...rnStyle };
    
    // Handle resizeMode
    if (resizeMode) {
      switch (resizeMode) {
        case 'contain':
          cssStyle.objectFit = 'contain';
          break;
        case 'cover':
          cssStyle.objectFit = 'cover';
          break;
        case 'stretch':
          cssStyle.objectFit = 'fill';
          break;
        case 'center':
          cssStyle.objectFit = 'none';
          cssStyle.objectPosition = 'center';
          break;
        default:
          cssStyle.objectFit = 'fill';
      }
    }
    
    return cssStyle;
  };
  
  const processedStyle = Array.isArray(style) 
    ? style.reduce((acc, s) => ({ ...acc, ...convertStyle(s) }), {})
    : convertStyle(style);
  
  // Handle different source formats
  let src = source;
  if (typeof source === 'object') {
    src = source.uri || source.default || source;
  }
  
  return (
    <img
      src={src}
      alt={alt || ''}
      style={processedStyle}
      {...props}
    />
  );
};

export default Image;